import { useState, useContext, useEffect } from 'react'
import { SceneContext } from './SceneContext'
import { useHistory }  from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'

import './css/NavButton.css'

export default function NavButton(props) {
    const [state, setState] = useState({
        img_folder: 'images/',
        box_color: getRandomColor(),
        opacity: 'opacity-off'
    })
    
    const context = useContext(SceneContext)
    const history = useHistory()

    useEffect(() => position_label(props, state, setState, context), [props])
    
    return (
        <div className={"navButton"}>
            { render_imgs(props, state, setState, context, history) }
            { render_label(props, state, context) }
        </div>
    )
}

function render_imgs(props, state, setState, context, history) {
    let ab = []
    let imgs = context.selected_scene_data.NavButtons[props.index].imgs
    
    ab = imgs.slice(0).reverse().map((d, img_index) => {
        
        let src                 = state.img_folder + d.src
        let style               = computeImgStyle(d, state, context, props)
        let box_index           = props.index
        let img_index_reverse   = imgs.length - img_index - 1

        let nav_to = context.selected_scene_data.NavButtons[props.index].nav_to

       return (    
                    <img 
                        index={ 'navButton-' + box_index + '-' + img_index_reverse } 
                        key={ img_index }
                        id={ 'nb-'+props.index+ '-' + img_index_reverse }
                        alt="IMG not found" 
                        draggable="false" 
                        className={ "selectable img_" + d.type }
                        src={src} 
                        style={style}                        

                        onMouseEnter={ () => context.activateNavButton(props.index) }
                        onMouseLeave={ () => context.deactivateNavButton() }
                        onClick={ (e) =>{ if(!context.dev_mode){ if(nav_to) history.push(nav_to) } else { context.setMoveableElement(e) } } }
                    /> 
                )
    })
    
    return ab
}

function render_label(props, state, context) {
    let label = context.selected_scene_data?.NavButtons[props.index]?.label
    
    if(label) {
        return <div id={'lb-'+props.index} className={'navLabel'} style={{top: state.label_y, left: state.label_x, opacity: context.nav_state[props.index] ? 1 : 0, zIndex: context.nav_state[props.index] ? 9999 : -9999 }}>{label.text}</div>
    }
}

function position_label(props, state, setState, context) {
    let imgs = context.selected_scene_data?.NavButtons[props.index]?.imgs
    let label = context.selected_scene_data?.NavButtons[props.index]?.label
    
    if(label) {
        let label_el = document.querySelector('#lb-'+props.index)
        let img_el = document.querySelector('#nb-'+props.index+'-1')

        let x_base = img_el.width
        
        let label_width = label_el.offsetWidth
        let label_height = label_el.offsetHeight
        
        let label_x = imgs[0].x - (label_width - x_base)/2
        let label_y =  imgs[0].y - label_height - 15
        
        label_el.style.top = label_y+'px'
        label_el.style.left = label_x+'px'
    }
}

function computeImgStyle(data, state, context, props) {
    let is_active = context.nav_state[props.index]

    //let filter = 'sepia(100%)'
    let filter = ''

    if(data.type == 'main')
        if(is_active) 
            filter = 'drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.5)) '
        else
            filter = 'drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.5)) '

    if(data.no_filter)
        filter = ''

    filter = ''

    let style = { 
                    top: data.y,
                    left: data.x, 
                    transform: data.transform, 
                    border: context.dev_mode? ('1px solid ' + state.box_color) : ('1px solid rgba(0,0,0,0)'),
                    transition: data.transition || '',
                    filter: filter
                }
    
    if (context.dev_mode === false) {

        if(is_active && data.type === 'main')
            if(data.hide === false)
                style.opacity = 1
            else
                style.opacity = 0
        else if(is_active && data.type === 'hover')
            style.opacity = 1
        else if(!is_active && data.type === 'main')
            style.opacity = 1
        else if(!is_active && data.type === 'hover')
            style.opacity = 0
    } else {
        style.opacity = 1
    }
    
    return style
}

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}